import React from 'react';
import PropTypes from 'prop-types';

const ColumnShared = (props) => {
    if (props.data) {
        return <span>{props.data}</span>;
    }
    return <span>—</span>;
};

ColumnShared.propTypes = {
    data: PropTypes.any
};

export default ColumnShared;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/ColumnShared.js